import { Button } from 'react-bootstrap';
import { useLongPress } from 'use-long-press';
import { RecallValue } from '../../types/TrainingTypes';

const threshold = 300;
const cancelOnMovement = 50;

export default function RecallAssess(props: { assess: (x: RecallValue) => void }) {

    const longPress0 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && props.assess(RecallValue.Reset),
    });
    const longPress1 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && props.assess(RecallValue.MinimalDecrease),
    });
    const longPress2 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && props.assess(RecallValue.MinimalIncrease),
    });
    const longPress3 = useLongPress(() => { }, {
        threshold,
        cancelOnMovement,
        onFinish: x => x.type === 'pointerup' && props.assess(RecallValue.KnowExcellent),
    });

    return (
        <div className="assess-panel width-limit">
            <div className="row g-2">
                <div className="col-6">
                    <Button variant="light"
                        size="lg"
                        className="px-0 text-nowrap overflow-hidden"
                        onClick={() => props.assess(RecallValue.DoNotKnow)}
                        {...longPress0()}>
                        I don't know
                    </Button>
                </div>

                <div className="col-6">
                    <Button variant="light"
                        size="lg"
                        className="px-0 text-nowrap overflow-hidden"
                        onClick={() => props.assess(RecallValue.NotSure)}
                        {...longPress1()}>
                        I'm not sure
                    </Button>
                </div>

                <div className="col-6">
                    <Button variant="light"
                        size="lg"
                        className="px-0 text-nowrap overflow-hidden"
                        onClick={() => props.assess(RecallValue.Know)}
                        {...longPress2()}>
                        I know
                    </Button>
                </div>

                <div className="col-6">
                    <Button variant="light"
                        size="lg"
                        className="px-0 text-nowrap overflow-hidden"
                        onClick={() => props.assess(RecallValue.KnowWell)}
                        {...longPress3()}>
                        I know well
                    </Button>
                </div>
            </div>
        </div>
    );
}